import { ACTIONS } from '../actions/actionTypes';
import update from 'immutability-helper';

const INITIAL_STATE = {
    input: {},
    user: {},
    whatsNext: null,
    selectedCourses: [],
    graduatedCourses: [],
    loadingData: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
    case ACTIONS.USER_INPUT_CHANGED: {
        let obj = {};
        obj[action.payload.key] = action.payload.value;
        return update(state,
              {input: {$merge: obj}}
          );
    }
    case ACTIONS.USER_SELECTED_COURSES:
        return {...state, selectedCourses: action.payload};
    case ACTIONS.USER_SET_GRADUATED_COURSE:
        return {...state, graduatedCourses: action.payload};
    case ACTIONS.USER_SET_DATA:
        return {...state, user: action.payload};
    case ACTIONS.USER_SET_WHATSNEXT:
        return {...state, whatsNext: action.payload};
    case ACTIONS.USER_SET_LOADING_DATA:
        return {...state, loadingData: action.payload};
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js